import Base from 'app/models/base';

export default Base.extend({
  defaults: {
    readable: '',
    route: '',
    aclField: '',
    isSubItem: false,
  },

  initialize() {},
});



// WEBPACK FOOTER //
// ./app/models/account_nav_item.js